import React from "react";
import { Divider, Grid, Paper, Typography } from "@material-ui/core";
import { Topbar } from "@components";
import { AccommodationRequestForm } from "./AccommodationRequestForm";
import { AccommodationRequestProps } from "./AccommodationRequestProps";
import { BookingGroupCard } from "../../BookingGroupCard/BookingGroupCard";
import { useLocale } from "@hooks";

type Props = {
  formProps: AccommodationRequestProps;
};

export function AccommodationRequestPage(props: Props) {
  const { locale } = useLocale();

  const isBookingGroupContext = !!props.formProps.bookingGroupId;
  const title = isBookingGroupContext
    ? locale.newTravelOrAccommodationRequest
    : locale.newAccommodationRequest;

  return (
    <Grid container spacing={2} style={{ padding: 16, marginTop: -16 }}>
      <Grid item xs={12}>
        <Topbar>
          <Typography variant="h6">{title}</Typography>
        </Topbar>

        <Divider style={{ margin: "8px -16px 0" }} />

        {isBookingGroupContext && (
          <Grid item xs={12} style={{ marginTop: 16 }}>
            <BookingGroupCard bookingGroupId={props.formProps.bookingGroupId} />
          </Grid>
        )}

        <Grid item xs={12} style={{ marginTop: 16 }}>
          <Paper style={{ padding: 16 }}>
            <AccommodationRequestForm {...props.formProps} />
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
}
